import { profileApi } from "@/core/data/api";

export default async (userId) => {
  return await profileApi.saveProfile(userId);
};
